import * as Types from '../constants/Types';

const initialState = {
    isFetching: false,
    isFetchingMultiple: false,
    fieldName: undefined,
};

export default (state = initialState, action) => {
    switch (action.type) {
        case Types.UPLOAD_FILE_ACTION:
            return {
                isFetching: action.filters.isFile === 1,
                // isFetching: action.filters.directory === 'avatar',
                isFetchingMultiple: action.filters.isFile === 2,
                // isFetchingMultiple: action.filters.directory === 'images'
                fieldName: action.filters.fieldName,
            };
        case Types.UPLOAD_FILE_RESET:
            return {isFetching: false, isFetchingMultiple: false, fieldName: initialState.fieldName};
        case Types.UPLOAD_FILE_SUCCESS:
            return {...state, isFetching: false, isFetchingMultiple: false, file: action.file, fieldName: action.fieldName};
        default:
            return state;
    }
}
